export default {
  setLeadData({ commit }, data) {
    commit('SET_DATA_LEAD', data)
  },

  clearData({ commit }) {
    commit('CLEAR_DATA')
  },
}
